export default "__VITE_ASSET__DErYO6tz__"